/**
 * Hook di rete per il modulo BI: invia una domanda a POST /bi/ask.
 *
 * Responsabilità: SOLO la rete. Nessuna gestione di UI o di errori a schermo.
 * - Usa l'istanza axios centralizzata: il Bearer JWT è aggiunto dall'interceptor
 *   di '@/lib/axios' (nessun token da gestire qui).
 * - baseURL è già '/api/v1', quindi il path è '/bi/ask'.
 *
 * Distinzione errori (da NON mescolare):
 * - trasporto/auth (es. 401, 500, rete): axios lancia -> finiscono in `error`;
 * - "business" (SQL/esecuzione): HTTP 200 con { ok: false, phase, message } ->
 *   arriva in `data` (variante BiAskError della union). Chi consuma il hook
 *   controllerà `data.ok`. Qui non serve altra logica.
 */

import { useMutation } from '@tanstack/react-query'

import axiosInstance from '@/lib/axios'
import type { BiAskRequest, BiAskResponse } from './types'

async function postBiAsk(payload: BiAskRequest): Promise<BiAskResponse> {
  const { data } = await axiosInstance.post<BiAskResponse>('/bi/ask', payload)
  return data
}

/**
 * useMutation su /bi/ask. Ritorna l'oggetto della mutation
 * (mutate, mutateAsync, data, isPending, error, ...).
 */
export function useBiAsk() {
  return useMutation<BiAskResponse, unknown, BiAskRequest>({
    mutationFn: postBiAsk,
  })
}
